import { IconButton, Pagination } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { DataGrid, GridToolbarColumnsButton } from "@mui/x-data-grid";
import { useCallback, useEffect, useState } from "react";
import { getPermissionData, getUserData } from "../../Actions/common";
import {
  deleteMultipleUsersByIdAction,
  getUserDetailByIdAction,
  getUsersAction,
  unblockUserAction,
  updateUserStatusAction,
} from "../../Actions/UserActions";
import {
  MyAddRoundedIcon,
  MyDeleteOutlineOutlinedIcon,
  MyEditOutlinedIcon,
  MySearchIcon,
  MyUnblockIcon,
} from "../../Assets/svg/MyIcons";
import { ITEMS_PER_PAGE_OPTIONS, MEDIA_URL, REACT_APP_PROFILE_FOLDER_NAME } from "../../config";
import CustomSnackbar from "../Common/snackBar";
import ExportDataModal from "../ExportDataModal";
import AddEditMasterUserModal from "./AddEditUser";

import Avatar from "@mui/material/Avatar";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import { getRoleAction } from "../../Actions/RoleActions";
import { getTenantAction } from "../../Actions/TenantActions";
import { DataGrid_SX } from "../../Assets/customTheme/constants";
import { CustomNoRowsOverlay } from "../../Assets/customTheme/CustomNoRowsOverlay";
import {
  default as CoustomTooltip,
  default as CustomTooltip,
} from "../../Assets/customTheme/customtooltip";
import { TableColumns, TableFilte, TableReset } from "../../Assets/svg/svgicon";
import BreadcrumbsComponent from "../../components/Common/Breadcrumbs";
import { CommonTooltip } from "../../utils/tooltip";
import showConfirmation from "../../utils/Conformation";
import PowerSettingsNewOutlinedIcon from "@mui/icons-material/PowerSettingsNewOutlined";


const CustomToolbar = ({
  selectedRows,
  handleDeleteSelected,
  searchValue,
  handleSearchApi,
  handleFilterData,
  handleResetFilters,
  handleChangeDropdown,
  statusFilter,
  handleAddUnitRate,
  masterUserData,
  hasPermission,
  filterButtonDisabled,
  resetButtonDisabled,
}) => {
  return (
    <div className="custom-header ">
      <div className="card border-rounded-0 fiter-card">
        <div className="card-body p-5 pb-0">
          <div className="row">
            <div className="col-xl-3 col-xxl-2 col-lg-3 col-md-4 col-sm-6  mb-5 ">
              <div className="input-group w-100">
                <div className="input-group-prepend">
                  <span className="input-group-text" id="basic-addon1">
                    <MySearchIcon />
                  </span>
                </div>
                <input
                  type="text"
                  data-kt-table-widget-4="search"
                  className="form-control"
                  placeholder="Search"
                  name="search"
                  value={searchValue}
                  onChange={handleSearchApi}
                />
              </div>
            </div>

            <div className="col-xl-3 col-xxl-2 col-lg-3 col-md-3 col-sm-6  mb-5">
              <FormControl className="w-100">
                <Select
                  displayEmpty
                  value={statusFilter}
                  name="dropdown"
                  onChange={(e) => handleChangeDropdown(e, "status")}
                  input={<OutlinedInput />}
                  sx={{
                    "& .MuiSelect-select": {
                      padding: "12px 10px",
                      textAlign: "start",
                      minHeight: "1em !important",
                    },
                    fieldset: {
                      borderColor: "#e1e3ea !important",
                      borderRadius: "0.475rem",
                    },
                  }}
                >
                  <MenuItem value="all">All Status</MenuItem>
                  <MenuItem value="1">Active</MenuItem>
                  <MenuItem value="0">Inactive</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="col-auto ms-auto d-flex gap-3 mb-5 align-items-center ">
              <CustomTooltip title="Filter" placement="top" arrow>
                <span>
                  <button
                    className="btn text-primary btn-light btn-icon"
                    onClick={handleFilterData}
                    disabled={filterButtonDisabled}
                  >
                    <TableFilte />
                  </button>
                </span>
              </CustomTooltip>

              <CustomTooltip title="Reset" placement="top" arrow>
                <span>
                  <button
                    className="btn text-primary btn-light btn-icon"
                    onClick={handleResetFilters}
                    disabled={resetButtonDisabled}
                  >
                    <TableReset />
                  </button>
                </span>
              </CustomTooltip>


              {/* <CoustomTooltip title="Column" placement="top" arrow>
                                        <span className="btn text-primary btn-light btn-icon grid-toolbar">
                                    
                                        <TableColumns/>

                                        
                                        </span>
                                    </CoustomTooltip> */}

              <CoustomTooltip title="Column" placement="top" arrow>
                <GridToolbarColumnsButton
                  slotProps={{
                    button: {
                      className:
                        "btn btn-light text-primary btn-icon grid-toolbar d-flex justify-content-center align-items-center p-0",
                      style: {
                        width: "47px",
                        height: "44px",
                        minWidth: "unset",
                        borderRadius: "8px",
                      },
                      startIcon: <TableColumns />,
                    },
                  }}
                />
              </CoustomTooltip>

              {selectedRows.length !== 0 && (
                <CoustomTooltip title="Delete" placement="top" arrow>
                  <span>
                    <button
                      className="btn btn-outline-danger btn-icon btn-outline "
                      onClick={handleDeleteSelected}
                      disabled={selectedRows.length === 0}
                    >
                      <MyDeleteOutlineOutlinedIcon />
                    </button>
                  </span>
                </CoustomTooltip>
              )}

              {hasPermission?.canCreate && (
                <button
                  className="btn btn-primary btn-add "
                  onClick={(e) => handleAddUnitRate(e)}
                >
                  <MyAddRoundedIcon className="me-1 text-white" /> ADD
                </button>

              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const MasterUserSection = () => {
  const [masterUserData, setMasterUserData] = useState([]);
  const [filterButtonDisabled, setFilterButtonDisabled] = useState(true);
  const [resetButtonDisabled, setResetButtonDisabled] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [masterUserDataById, setMasterUserDataById] = useState(null);
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState("all");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [shouldFetchData, setShouldFetchData] = useState(1);
  const [openExportModal, setOpenExportModal] = useState(true);
  const [selectedDataForExport, setSelectedDataForExport] = useState([]);
  const [exportData, setExportData] = useState({});
  const [roles, setRoles] = useState([]);
  const [merchantUser, setMerchantUser] = useState([]);
  const [selectedRowsPerPage, setSelectedRowsPerPage] = useState(
    ITEMS_PER_PAGE_OPTIONS[0]
  );
  const profileFolderName = REACT_APP_PROFILE_FOLDER_NAME || "profilePics";

  const userData = localStorage.getItem("userData") ? getUserData() : null;
  const permissionData = localStorage.getItem(`${userData?.id}_permissionData`)
    ? getPermissionData(`${userData?.id}_permissionData`)
    : [];
  const hasPermission = permissionData[0]?.role_permissions?.find(
    (m) => m?.module && m?.module?.slug === "users"
  );
  const getMasterUserData = useCallback(async () => {
    setLoading(true);
    await getUsersAction(
      currentPage,
      searchValue,
      // ITEMS_PER_PAGE.value,
      selectedRowsPerPage,
      statusFilter
    )
      .then((res) => {
        const { data, totalRecords } = res?.data;
        setMasterUserData(data.rows);
        setExportData(data.rows);
        setTotalRecords(totalRecords);
        setLoading(false);
      })
      .catch((error) => {
        setSnackbar({
          open: true,
          message: error.response?.data?.message,
          severity: "error",
        });
      });
    setLoading(false);
  }, [currentPage, searchValue, selectedRowsPerPage, statusFilter]);
  useEffect(() => {
    if (shouldFetchData) {
      getMasterUserData();
      setShouldFetchData(0);
    }
  }, [shouldFetchData, getMasterUserData]);

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };



  const handleAddUnitRate = async (e, id) => {
    if (id) {
      await getUserDetailByIdAction(id)
        .then((res) => {
          setMasterUserDataById(res?.data?.data?.data);
          setOpenModal(true);
        })
        .catch((error) => {
          setSnackbar({
            open: true,
            message: error?.response?.data?.message,
            severity: "error",
          });
        });
    } else {
      setOpenModal(true);
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setMasterUserDataById(null);
    if (shouldFetchData) {
      setShouldFetchData(1);
    }
  };

  const handleDeleteUser = async (e, deleteId) => {
    e.stopPropagation();

    await showConfirmation("simpleDelete", {
      entityName: "User",
      entityId: deleteId,
      action: async (id) => {
        return await deleteMultipleUsersByIdAction(id);
      },
      onSuccess: () => {
        getMasterUserData();
      },
      onError: (error) => {
        setSnackbar({
          open: true,
          message: error.response?.data?.message,
          severity: "error",
        });
      },
      showCancelledMsg: true,
    });
  };

  const handleSearchApi = (e) => {
    const inputValue = e.target.value.trim();
    setSearchValue(inputValue);
    if (inputValue.length > 0) {
      setFilterButtonDisabled(false);
    } else {
      setFilterButtonDisabled(true);
    }
  };

  const changeMasterUserStatus = async (e, ele) => {
    e.stopPropagation();

    await showConfirmation("toggleStatus", {
      entityName: "User",
      entityId: ele.id,
      currentStatus: ele.isActive,
      action: async ({ id }) => {
        return await updateUserStatusAction(id, ele.isActive);
      },
      onSuccess: (res) => {
        setSnackbar({
          open: true,
          message: res?.data?.message,
          severity: "success",
        });
        getMasterUserData();
      },
      onError: (error) => {
        setSnackbar({
          open: true,
          message: error.response?.data?.message,
          severity: "error",
        });
      },
    });
  };
  // const handleRowSelection = (event, ele) => {
  //   const selectedId = ele.id;

  //   if (event.target.checked) {
  //     // Add the selected ID to the array
  //     setSelectedRows((prevSelectedRows) => [...prevSelectedRows, selectedId]);
  //     setSelectedDataForExport((prevSelectedRows) => [
  //       ...prevSelectedRows,
  //       selectedId,
  //     ]);
  //   } else {
  //     // Remove the selected ID from the array
  //     setSelectedRows((prevSelectedRows) =>
  //       prevSelectedRows.filter((id) => id !== selectedId)
  //     );
  //     setSelectedDataForExport([]);
  //   }
  // };

  // const handleSelectAll = (event) => {
  //   if (event.target.checked) {
  //     // Select all records
  //     const allIds = masterUserData.map((ele) => ele.id);
  //     setSelectedRows(allIds);
  //     setSelectedDataForExport(allIds);
  //   } else {
  //     // Deselect all records
  //     setSelectedRows([]);
  //     setSelectedDataForExport([]);
  //   }
  // };

  const getMerchantUser = async () => {
    await getTenantAction(null, null, null, null, "1")
      .then((res) => {
        const { data } = res.data;
        setMerchantUser(data);
      })
      .catch((error) => {
        setSnackbar({
          open: true,
          message: error.response?.data?.message,
          severity: "error",
        });
      });
    setLoading(false);
  };

  const handleDeleteSelected = async () => {
    if (selectedRows.length === 0) return;

    await showConfirmation("simpleMultipleDelete", {
      entityName: "User",
      entityIds: selectedRows,
      action: async (ids) => {
        return await deleteMultipleUsersByIdAction(ids);
      },
      onSuccess: () => {
        setSelectedRows([]);
        setCurrentPage(1);
        getMasterUserData();
      },
      onError: (error) => {
        setSnackbar({
          open: true,
          message: error.response?.data?.message,
          severity: "error",
        });
        setSelectedRows([]);
      },
      showCancelledMsg: true,
    });
  }

  const handleUnblockUser = async (e, userId) => {
    e.stopPropagation();
    await showConfirmation("customToggle", {
      entityName: "User",
      entityId: userId,
      customTitle: "Unblock User?",
      customText: "Are you sure you want to unblock this user?",
      confirmButtonText: "Yes, Unblock",
      confirmButtonColor: "#22419e",
      isActivating: true,
      action: async (id) => {
        return await unblockUserAction(id);
      },
      onSuccess: (res) => {
        setSnackbar({
          open: true,
          message: res?.data?.message || res?.message,
          severity: "success",
        });
        getMasterUserData();
      },
      onError: (error) => {
        setSnackbar({
          open: true,
          message: error.response?.data?.message,
          severity: "error",
        });
      },
    });
  };

  const handlePaginationChange = (event, value) => {
    setMasterUserData([]);
    setSelectedRows([]);
    setCurrentPage(value);
    setShouldFetchData(1);
  };

  const handleChangeDropdown = (e, filterName) => {
    const selectedAction = e.target.value;
    if (filterName === "status") {
      setStatusFilter(selectedAction);
    }
    if (selectedAction !== "all") {
      setFilterButtonDisabled(false);
    } else {
      setFilterButtonDisabled(true);
    }
  };

  const handleResetFilters = () => {
    setMasterUserData([]);
    setStatusFilter("all");
    setSearchValue(""); // Resetting the search value
    setCurrentPage(1); // Resetting the current page to the first page
    setShouldFetchData(1);
    setResetButtonDisabled(true);
    setFilterButtonDisabled(true);
  };

  const handleFilterData = () => {
    setLoading(true);
    setCurrentPage(1);
    setShouldFetchData(1);
    setMasterUserData([]);
    setLoading(false);
    setFilterButtonDisabled(true);
    setResetButtonDisabled(false);
  };

  const fetchRoles = () => {
    setLoading(true);
    getRoleAction("", true)
      .then((res) => {
        const { data } = res.data;
        setRoles(data);
        setLoading(false);
      })
      .catch((error) => {
        setSnackbar({
          open: true,
          message: error.response?.data?.message,
          severity: "error",
        });

        setLoading(false);
      });
  };

  useEffect(() => {
    fetchRoles();
    getMerchantUser();
  }, []);

  const stringAvatar = (profileData) => {
    return {
      children: `${profileData?.split("")[0]}`,
    };
  };

  const handleRowsPerPageChange = (event) => {
    setMasterUserData([]);
    setSelectedRows([]);
    const newValue = parseInt(event.target.value);
    setSelectedRowsPerPage(newValue);
    setCurrentPage(1);
    setLoading(true);
    setShouldFetchData(1);
  };
  const [imageError, setImageError] = useState(false);
  const columns = [
    // {
    //   field: "id",
    //   minWidth: 54,
    //   width: 54,
    //   headerName: "",
    //   sortable: false, // Disable sorting for this column
    //   filterable: false, // Disable filtering for this column
    //   disableColumnMenu: true,
    //   renderHeader: (params) => (
    //     <Checkbox
    //       onChange={handleSelectAll}
    //       disabled={masterUserData.length === 0}
    //       checked={
    //         masterUserData.length > 0 &&
    //         selectedRows.length === masterUserData.length
    //       }
    //       sx={MyCheckboxIcon}
    //     />
    //   ),
    //   renderCell: (params) => (
    //     <Checkbox
    //       onChange={(event) => handleRowSelection(event, params.row)}
    //       checked={selectedRows.includes(params.row.id)}
    //       sx={MyCheckboxIcon}
    //     />
    //   ),
    // },
    {
      field: "firstName",
      renderCell: (params) => {
        const hasLogo = params.row.profilePic && !imageError;

        return (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              padding: "0px 0",
            }}
          >
            {hasLogo ? (
              <img
                  src={`${MEDIA_URL}/qbotmasterapp.netcluesdemo.com/${profileFolderName}/${params.row.profilePic}`}
                  height="40px"
                  width="40px"
                  alt={`${params.row.firstName?.charAt(0) || ""}`}
                  style={{
                    marginRight: "10px",
                    background: "#bfcfff",
                    objectFit: "cover",
                    borderRadius: "40px",
                    color: "#23419e",
                  }}
                  onError={() => setImageError(true)}
                />
            ) : (
              <Avatar
                {...stringAvatar(JSON.parse(params.row.firstName))}
                className="h-40px w-40px rounded-5 bg-primary-subtle text-primary mr-5"
                style={{
                  marginRight: "10px",
                }}
              />
            )}
            <span
              style={{
                fontSize: "16px",
                fontWeight: "500",
                color: "#333",
              }}
            >
              {params.row.firstName ? JSON.parse(params.row.firstName) : "N/A"}
            </span>
          </div>
        );
      },
      minWidth: 220,
      headerName: "First Name",
      flex: 1,
    },

    {
      field: "lastName",
      minWidth: 150,
      headerName: "Last Name",
      flex: 1,
      renderCell: (params) => (
        <span style={{ fontSize: "16px", fontWeight: "500", color: "#333" }}>
          {params.row.lastName ? JSON.parse(params.row.lastName) : "N/A"}
        </span>
      ),
    },
    {
      field: "email",
      minWidth: 150,
      headerName: "Email",
      flex: 1,
      renderCell: (params) => (
        <span style={{ fontSize: "16px", fontWeight: "500", color: "#333" }}>
          {params.row.email ? JSON.parse(params.row.email) : "N/A"}
        </span>
      ),
    },
    // {
    //   field: "unblock",
    //   minWidth: 120,
    //   headerName: "Unblock",
    //   sortable: false,
    //   renderCell: (params) =>
    //     params.row.isBlocked ? (
    //       <CommonTooltip title="Unblock" placement="top" arrow>
    //         <IconButton
    //           className="btn-custom-i text-primary"
    //           onClick={(e) => handleUnblockUser(e, params.row.id)}
    //         >
    //           <MyUnblockIcon fontSize="small" />
    //         </IconButton>
    //       </CommonTooltip>
    //     ) : null,
    // },
    // {
    //   field: "roleName",
    //   minWidth: 150,
    //   headerName: "Role",
    //   flex: 1,
    //   renderCell: (params) => (
    //     <span style={{ fontSize: "16px", fontWeight: "500", color: "#333" }}>
    //       {params.row.role?.roleName || "No Role"}
    //     </span>
    //   ),
    // },
    ...(hasPermission?.canEdit || hasPermission?.canDelete
      ? [
        {
          field: "actions",
          headerName: "Actions",
          sortable: false,
          minWidth: 220,
          renderCell: (params) => (
            <div className="d-flex align-items-center justify-content-center w-100 h-100">
              {/* Unblock Button - Only show if user is blocked */}
              {params.row.isBlocked && hasPermission?.canEdit && (
                <CommonTooltip title="Unblock" placement="top" arrow>
                  <IconButton
                    className="btn-custom-i text-primary me-3"
                    onClick={(e) => handleUnblockUser(e, params.row.id)}
                  >
                    <MyUnblockIcon fontSize="small" />
                  </IconButton>
                </CommonTooltip>
              )}

              {/* Activate/Deactivate Button */}
              {hasPermission?.canEdit && (
                <CommonTooltip
                  title={params.row?.isActive ? "Deactivate User" : "Activate User"}
                  placement="top"
                  arrow
                >
                  <IconButton
                    className="btn-custom-i text-primary me-3"
                    onClick={(e) => changeMasterUserStatus(e, params.row)}
                  >
                    <PowerSettingsNewOutlinedIcon
                      fontSize="small"
                      color={params.row?.isActive ? "error" : "success"}
                    />
                  </IconButton>
                </CommonTooltip>
              )}

              {hasPermission?.canEdit && (
                <CommonTooltip title="Edit" placement="top" arrow>
                  <IconButton
                    className="btn-custom-i text-primary me-3"
                    onClick={(e) => handleAddUnitRate(e, params.row.id)}
                  >
                    <MyEditOutlinedIcon />
                  </IconButton>
                </CommonTooltip>
              )}

              {/* Delete Button */}
              {hasPermission?.canDelete && (
                <CommonTooltip title="Delete" placement="top" arrow>
                  <IconButton
                    className="btn-custom-i text-primary me-3"
                    onClick={(e) => handleDeleteUser(e, params.row.id)}
                  >
                    <MyDeleteOutlineOutlinedIcon />
                  </IconButton>
                </CommonTooltip>
              )}
            </div>
          ),
        },
      ]
      : []),
  ];

  return (
    <div id="kt_content_container">
      <BreadcrumbsComponent />
      <DataGrid
        className="border-0"
        localeText={{ toolbarColumns: "" }}
        rows={masterUserData}
        columns={columns}
        autoHeight
        hideFooterRowCount={true}
        hideFooterPagination={true}
        hideFooter={true}
        loading={loading}
        slots={{
          toolbar: CustomToolbar,
          noRowsOverlay: CustomNoRowsOverlay,
        }}
        slotProps={{
          toolbar: {
            selectedRows,
            handleDeleteSelected,
            searchValue,
            handleSearchApi,
            handleFilterData,
            handleResetFilters,
            handleChangeDropdown,
            statusFilter,
            handleAddUnitRate,
            masterUserData,
            hasPermission,
            filterButtonDisabled,
            resetButtonDisabled,
          },
        }}
        components={{
          loadingOverlay: () => (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100px",
              }}
            >
              <CircularProgress
                color="primary"
                size={24}
                style={{
                  marginRight: 10,
                }}
              />
              Loading...
            </div>
          ),
          noRowsOverlay: () =>
            loading ? null : (
              <div
                style={{
                  display:
                    !loading && masterUserData.length === 0 ? "block" : "none",
                  fontWeight: "bold",
                  textAlign: "center",
                  padding: "20px",
                }}
              >
                No Records Found
              </div>
            ),
        }}
        sx={DataGrid_SX}
      />
      <div className="card-footer d-flex align-items-center justify-content-between mt-7">
        <div className="d-flex align-items-center">
          <label className="fw-semibold me-3">{"Row per page"} </label>
          <FormControl
            variant="standard"
            style={{
              minWidth: 50,
            }}
          >
            <Select
              labelId="rows-per-page-label"
              id="rows-per-page"
              value={selectedRowsPerPage}
              onChange={handleRowsPerPageChange}
              label="Row per page"
            >
              {ITEMS_PER_PAGE_OPTIONS?.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <Pagination
          count={Math.ceil(totalRecords / selectedRowsPerPage)}
          siblingCount={0}
          page={currentPage}
          onChange={(event, value) =>
            value !== currentPage ? handlePaginationChange(event, value) : null
          }
          variant="outlined"
          shape="rounded"
          className="custom-pagination mt-0 ms-5"
        />
      </div>
      {/* </div>
                    </div>
                </div>
            </div> */}
      {openModal ? (
        <AddEditMasterUserModal
          open={openModal}
          handleClose={handleCloseModal}
          masterUserDataById={masterUserDataById}
          setSnackbar={setSnackbar}
          roles={roles}
          merchantUser={merchantUser}
          setShouldFetchData={setShouldFetchData}
        />
      ) : null}
      {!openExportModal && (
        <ExportDataModal
          isOpen={openExportModal}
          onClose={() => {
            setOpenExportModal(false);
          }}
          blobData={exportData}
          data={selectedDataForExport}
          setSnackbar={setSnackbar}
        />
      )}
      <CustomSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={handleCloseSnackbar}
      />
    </div>
  );
};

export default MasterUserSection;
